import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Cosign.svg'

export const IconCosign = IconSVG as IconComponent
